import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Clinic, UpdateClinicRequest } from '../../models';

@Injectable({ providedIn: 'root' })
export class ClinicApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/v1/settings`;

  getClinic$(): Observable<Clinic> {
    return this.http.get<Clinic>(`${this.baseUrl}/clinic`);
  }

  getClinic(): Promise<Clinic> {
    return firstValueFrom(this.getClinic$());
  }

  updateClinic$(body: UpdateClinicRequest): Observable<Clinic> {
    return this.http.put<Clinic>(`${this.baseUrl}/clinic`, body);
  }

  updateClinic(body: UpdateClinicRequest): Promise<Clinic> {
    return firstValueFrom(this.updateClinic$(body));
  }
}
